module.exports = __webpack_public_path__ + "static/media/creditcard.5b27313e.gif";